import styled from "styled-components";

import { getOpacityColor, grayScale, pink } from "@enkor/design/colors";

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ImageWrapper = styled.div`
  position: relative;
`;

export const ImagePlaceholder = styled.div`
  position: relative;
  overflow: hidden;

  width: 100%;
  height: auto;
  aspect-ratio: 1/1;

  background-color: ${getOpacityColor(grayScale[300], 0.7)};
`;

export const DotsList = styled.ul`
  position: absolute;
  bottom: 10px;
  left: 50%;
  display: flex;
  gap: 8px;

  transform: translateX(-50%);

  li {
    left: 50%;

    width: 8px;
    height: 8px;
    border-radius: 50%;

    background-color: ${getOpacityColor(grayScale.white, 0.4)};

    &:first-child {
      background-color: ${pink.main};
    }
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  padding: 16px;
`;

const Skeleton = styled.div`
  border-radius: 2px;

  background-color: ${getOpacityColor(grayScale.white, 0.1)};
`;

export const TitleSkeleton = styled(Skeleton)`
  width: 223px;
  height: 32px;
  margin: 24px 0 16px;
`;

export const ContentSkeleton = styled(Skeleton)`
  width: 100%;
  height: 22px;
  margin-bottom: 8px;
`;
